/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { Base, markType } from "./type";
/**
 * @hidden
 */
var SummaryGroup = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(SummaryGroup, _super);
    function SummaryGroup() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.a = null;
        return _this;
    }
    SummaryGroup.$t = markType(SummaryGroup, 'SummaryGroup');
    return SummaryGroup;
}(Base));
export { SummaryGroup };
//# sourceMappingURL=SummaryGroup.js.map
